import { style } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { User } from 'app/core/Models/user';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { PrimeNGConfig } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { FuseConfigService } from '@fuse/services/config';
import { appConfig, Scheme } from './core/config/app.config';

@Component({
  selector: 'app-root',
  template: `
    <fuse-loading-bar></fuse-loading-bar>
    <router-outlet></router-outlet>
    <p-toast></p-toast>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex: 1 1 auto;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AppComponent implements OnInit {
  userProfile: User;
  navigation: FuseNavigationItem[];
  private _scheme: Scheme;

  /**
   * Constructor
   */
  constructor(
    private _navService: NavigationService,
    private primengConfig: PrimeNGConfig,
    private translocoService: TranslocoService,
    private fuseConfigService: FuseConfigService // private spService: SpService
  ) {
    localStorage.removeItem('layout');

    this._navService.updateNavigationByUserPermissions();
    this.primengConfig.ripple = true;
    this.scheme = appConfig.scheme;

    this.fuseConfigService.config$.subscribe({
      next: config => {
        if (this.scheme !== config.scheme) {
          this.scheme = config.scheme;
        }
      },
    });
  }

  ngOnInit(): void {
    const active = this.translocoService.getActiveLang();
    for (let _lang of this.translocoService.getAvailableLangs())
      if ((<any>_lang).id !== active)
        this.translocoService.load((<any>_lang).id).subscribe();
  }

  private get scheme(): Scheme {
    return this._scheme;
  }

  private set scheme(scheme: Scheme) {
    this._scheme = scheme;
    this.setPrimeNgScheme();
  }

  private setPrimeNgScheme() {
    let scheme: Scheme = this.scheme;

    const cssId = 'primeng-theme-link'; // you could encode the css path itself to generate id..
    let cssSrc = scheme === 'light' ? 'prime-light.css' : 'prime-dark.css';
    const overideLink = document.getElementById(
      'prime-override-style'
    ) as HTMLLinkElement;
    overideLink.href =
      scheme === 'light' ? 'override-light.css' : 'override-dark.css';

    const linkEl = document.getElementById(cssId) as HTMLLinkElement;
    if (!linkEl) {
      const head = document.getElementsByTagName('head')[0];
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = cssSrc;
      link.media = 'all';
      head.appendChild(link);
    } else {
      linkEl.setAttribute('href', cssSrc);
    }
  }
}
